import React from "react";

// project-import
import "../../assets/css/generic-document-viewer.css";

// third-party
import { Modal } from "react-bootstrap";
// Import the styles for pdf 
import { SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";

const GenericPdfViewer = ({ data, show, onCloseModal }) => {
    const transform = (slot) => ({
        ...slot,
        Download: () => <></>,
        DownloadMenuItem: () => <></>,
        EnterFullScreen: () => <></>,
        EnterFullScreenMenuItem: () => <></>,
        SwitchTheme: () => <></>,
        SwitchThemeMenuItem: () => <></>,
        Open: () => <></>,
        OpenMenuItem: () => <></>,
        Print: () => <></>,
        PrintMenuItem: () => <></>,
    });

    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    );
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
    });
    const { renderDefaultToolbar } = defaultLayoutPluginInstance.toolbarPluginInstance;
    const customTitle = data && data?.title ? `Free Preview | ${data?.title} | Longswtich Academy` : "Free Preview";

    return (
        <Modal
            className="rounded-lg"
            show={show}
            onHide={onCloseModal}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header closeButton className="px-5 pb-0 border-0">
                <Modal.Title
                    as={"h5"}
                    className="mb-0 fw-normal"
                >{customTitle}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row">
                    {/* <h4 className=" d-flex title justify-content-center mt--20">{data.title}</h4> Tile of the PDF doucment */}
                    <div className="">
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js"> {/* PDF.js worker URL */}
                            <div className="generic-media-viewer ">
                                <Viewer
                                    theme={{
                                        theme: 'dark', // Set the theme for the PDF viewer
                                    }}
                                    fileUrl={data.url} // URL of the PDF file to be diplayed
                                    enableSmoothScroll={true}
                                    defaultScale={SpecialZoomLevel.ActualSize}
                                    plugins={[defaultLayoutPluginInstance]}
                                />
                            </div>
                        </Worker>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="px-2">
                <button
                    className="edu-btn btn-small mx-1"
                    onClick={onCloseModal}
                >
                    Close
                </button>
            </Modal.Footer>
        </Modal>

    )
}

export default GenericPdfViewer;